import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        await exchangeGoogleSession(session_id);
        toast.success("Welcome to the Circle.");
        // Strip hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("We couldn't complete Google sign-in. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogleSession, navigate, location]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-brand-cream">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-brand-moss animate-spin mx-auto mb-3" />
        <p className="font-serif text-brand-moss text-lg">Bringing you into the Circle…</p>
      </div>
    </div>
  );
}
